module.exports = __webpack_public_path__ + "assets/img/explanation-demo.5f3aec02.png";